import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ConfigProvider, Modal, Button } from "antd";
import "antd/dist/reset.css";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { authProtectedRoutes, publicRoutes } from "./routes/index";
import { store } from "./redux/config/store";
import theme from "./styles/theme";
import MyLayout from "components/common/layout/sideBar";
import { PowerBIProvider } from "components/waste_overview/powerBI/powerbiContext";
import ErrorFallback from "components/common/error";
import { ErrorBoundary } from "react-error-boundary";
import { msalInstance } from "../src/sso/msalInstance";

const COOKIE_ACCEPTED = "strictlyNecessaryCookie";

function App() {
  const [cookieAccepted, setCookieAccepted] = useState(false);

  // Check if cookies are already accepted
  useEffect(() => {
    const consent = Cookies.get(COOKIE_ACCEPTED);
    if (consent) {
      setCookieAccepted(true);
    }
  }, []);

  // Handle acceptance of cookies
  const handleAcceptCookies = () => {
    Cookies.set(COOKIE_ACCEPTED, "true", { expires: 30 }); // Set a cookie for 1 year
    setCookieAccepted(true);
  };
  const handleDeclineCookies = () => {
    // Cookies.set(COOKIE_ACCEPTED, "false", { expires: 30 }); // Set a cookie for 1 year
    setCookieAccepted(true);
  };

  return (
    <Provider store={store}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <ConfigProvider theme={theme}>
          <BrowserRouter>
            <MsalProvider instance={msalInstance}>
              <AuthenticatedTemplate>
                <PowerBIProvider>
                  <MyLayout>
                    <Routes>
                      {authProtectedRoutes.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                    </Routes>
                  </MyLayout>
                </PowerBIProvider>
              </AuthenticatedTemplate>

              <UnauthenticatedTemplate>
                <Routes>
                  {publicRoutes.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Routes>

                {cookieAccepted == false  && (
                  <Modal
                    open
                    footer={null}
                    centered
                    closable={false}
                    width={600}
                    bodyStyle={{ textAlign: "center", fontSize: 16 }}
                  >
                    <p>
                      This site uses cookies required for secure login and to
                      ensure its proper functioning. By signing in, you consent
                      to the use of these cookies.
                    </p>

                    <div style={{ marginTop: 20 }}>
                      <Button
                        type="default"
                        onClick={handleDeclineCookies}
                        style={{ marginRight: 10 }}
                      >
                        Decline
                      </Button>
                      <Button
                        type="primary"
                        onClick={handleAcceptCookies}
                      >
                        Accept
                      </Button>
                    </div>
                  </Modal>
                )}
              </UnauthenticatedTemplate>
            </MsalProvider>
          </BrowserRouter>
        </ConfigProvider>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
